<form #formGroup="ngForm" *ngIf="user" (change)="storeStammdaten()">
  <p>
    <mat-form-field>
      <input matInput [(ngModel)]="user.vorname" name="vorname" placeholder="Vorname" autocomplete="given-name" required
             [disabled]="readonlyName">
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.nachname" name="nachname" placeholder="Nachname" autocomplete="family-name" required
             [disabled]="readonlyName">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <input matInput [(ngModel)]="user.strasse" name="strasse" placeholder="Straße Nr." autocomplete="street-address" required>
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.plz" name="plz" placeholder="PLZ" type="number" maxlength="5" autocomplete="postal-code" required>
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.ort" name="ort" placeholder="Ort" autocomplete="address-level2" required>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <input matInput [(ngModel)]="user.geburtsdatum" name="geburtsdatum" placeholder="Geburtsdatum"
             [min]="geburtsdatumMin" [max]="geburtsdatumMax"
             [matDatepicker]="geburtsdatumDatepicker" required>
      <!--<mat-datepicker-toggle matSuffix [for]="geburtsdatumDatepicker"></mat-datepicker-toggle>-->
      <mat-datepicker #geburtsdatumDatepicker startView="year" [startAt]="geburtsdatumInit"></mat-datepicker>
      <mat-hint align="start">für evtl. Jugend Ermäßigung</mat-hint>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <input matInput [(ngModel)]="user.geburtsland" name="geburtsland" placeholder="Geburtsland" autocomplete="country-name" required>
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.nationalitaet" name="nationalitaet" placeholder="Nationalität" autocomplete="country-name" required>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <input matInput [(ngModel)]="user.email" name="email" placeholder="E-Mail" type="email" autocomplete="email">
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.handy" name="handy" placeholder="Handy / WhatsApp" type="tel" autocomplete="tel" required>
    </mat-form-field>
    <mat-form-field>
      <input matInput [(ngModel)]="user.telefon" name="telefon" placeholder="Telefon" type="tel" autocomplete="tel">
    </mat-form-field>
  </p>

  <div [hidden]="formGroup.valid || formGroup.pristine" class="alert alert-warning">
    Bitte alle erforderlichen Felder (*) ausfüllen!
  </div>
</form>
